// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kUfc","delete":"styles_delete__evLQv","update":"styles_update__3KcY3","add":"styles_add__2eW6Z"};